module.exports = __webpack_public_path__ + "images/4c5e3240560502efc8e8fa8e47eaf153.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/images/intro_video/cuban_neighbourhood/susan_mobile.jpg
// module id = 170
// module chunks = 24